import { render, staticRenderFns } from "./TotalizerCorrectionModal.vue?vue&type=template&id=38fd8ce1&"
import script from "./TotalizerCorrectionModal.vue?vue&type=script&lang=ts&"
export * from "./TotalizerCorrectionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports